import type { ReactElement, ReactNode } from 'react'
import { Box } from '@mui/material'

interface Props {
  color: string
  children: ReactNode
}

/**
 * Field label carrying a dot in the colour its scene marker is drawn in, so a
 * hovered storey's markers can be traced back to the fields that position them.
 */
const CentroidFieldLabel = ({ color, children }: Props): ReactElement => (
  <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
    <Box
      component="span"
      sx={{
        width: 7,
        height: 7,
        borderRadius: '50%',
        backgroundColor: color,
        flexShrink: 0,
      }}
    />
    {children}
  </Box>
)

export default CentroidFieldLabel
